import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  withStyles,
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  IconButton,
  Tooltip,
  CircularProgress,
  Link,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Chip,
  Snackbar,
} from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";
import { AddOutlined, Clear, Info, ChevronLeft, ChevronRight } from "@material-ui/icons";
import axios from "axios";
import { fetchBusiness } from "../../store/businessState";
import LANGUAGES from "../../config/languages";
import { AUTH_LANGUAGES } from "../../config/languages";
import templateMsgHelper from "../../helpers/templateMsgHelper";

import { fetchProject } from "../../store/projectState";
import { createnewTemplate } from "./templateState";
import Switch from "@material-ui/core/Switch";
import { URL, projectURL, TENANT_ID, AISENSY_PARTNER_ID, NO_LABEL_URL, LINK_GEN_BACKEND_URL } from "../../config/config";
import TemplateMessagePreview from "../../commons/TemplateMessagePreview/templateMessagePreview";
import LockIcon from "@material-ui/icons/Lock";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import dialCodes from "../../config/dialCodes";
const TEMPLATE_CATEGORIES = ["UTILITY", "MARKETING", "AUTHENTICATION"];

const MSG_TYPES = [
  {
    type: "TEXT",
    name: "Text",
  },
  {
    type: "IMAGE",
    name: "Image",
  },
  {
    type: "VIDEO",
    name: "Video",
  },
  {
    type: "FILE",
    name: "Document",
  },
  {
    type: "LOCATION",
    name: "Location",
  },
  {
    type: "CAROUSEL",
    name: "Carousel",
    subType: "MARKETING",
  },
  {
    type: "LIMITED_TIME_OFFER",
    name: "Limited Time Offer",
    subType: "MARKETING",
  },
];

const CAROUSEL_MSG_TYPES = [
  { type: "IMAGE", name: "Image" },
  { type: "VIDEO", name: "Video" },
];

const DEFAULT_CAROUSEL_TEMPLATE = {
  templateFooter: "",
  buttons: [],
  parameters: [],
  mediaType: "IMAGE",
};

class CreateTemplateMsgForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionType: "None",
      callToAction: [],
      quickReplies: [],
      templateLabel: "",
      templateCategory: "",
      templateType: "",
      templateLanguage: "",
      templateName: "",
      templateFormat: "",
      templateSample: "",
      templateMediaURL: "",
      templateCTAUrl: "",
      templateHeader: "",
      templateFooter: "",
      isSubmitting: false,
      err: "",
      success: false,
      ctaUrlParam: 0,
      isClickTrackingEnabled: false,
      parameters: [],
      buttons: [],
      carouselButtons: [[]],
      carouselIndex: 0,
      carouselTemplates: [],
      carouselMediaType: "IMAGE",
      limitedTimeOffer: {},
      templateHeaderType: "",
      activePlan: "",
      draftId: "",
      cursor: 0,
      snackbar: {
        open: false,
        message: "",
      },
      alertMsg: "",
      alertType: "",
    };
    this.inputRef = React.createRef();
  }

  componentDidMount = () => {
    const { inDialog, template } = this.props;

    if (template) {
      let params = [];
      const regx = /{{([^}]+)}}/g;
      let curMatch;

      const format = template.format.split(" | ")[0];
      if (template.templateParams) params = template.templateParams;
      else
        while ((curMatch = regx.exec(format))) {
          params.push("");
        }

      for (let i = 0; i < template.callToAction.length; i++) {
        if (template.callToAction[i].type === "Phone Number") {
          //if ext exists update phone val
          if (template.callToAction[i].extension) {
            const ext = template.callToAction[i].extension.length;
            const len = template.callToAction[i].buttonValue.length;
            template.callToAction[i].buttonValue = template.callToAction[
              i
            ].buttonValue.substring(ext, len);
          }
          //set ext if possible
          else if (template.callToAction[i].buttonValue.length > 10) {
            const len = template.callToAction[i].buttonValue.length;
            template.callToAction[i].extension = template.callToAction[
              i
            ].buttonValue.substring(0, len - 10);

            template.callToAction[i].buttonValue = template.callToAction[
              i
            ].buttonValue.substring(len - 10, len);
          }
        }
      }
      //Later: templateCTAUrl sampleCTAUrl
      const action = template.callToAction.find((i) => i.type === "URL");
      const ctaUrlParam = action
        ? (action.buttonValue.match(/\{\{[0-9]+\}\}/g) || []).length
        : 0;

      this.setState({
        templateLabel: template.label,
        templateCategory: template.category,
        templateType: template.type,
        templateLanguage: template.language || template.templateLanguage,
        templateName: template.name,
        templateFormat: format,
        templateSample: template.sampleMessage,
        actionType: template.actionType,
        callToAction: template.callToAction,
        quickReplies: template.quickReplies,
        templateMediaURL: template.templateMediaURL,
        templateCTAUrl: action ? action.buttonValue : "",
        parameters: params,
        templateHeader: template.headerText ?? "",
        templateFooter: template.footerText ?? "",
        draftId: template._id,
        ctaUrlParam,
        codeExpiryMinutes: template.codeExpiryMinutes || "",
        viewSecurityMessage: template.viewSecurityMessage || false,
        isClickTrackingEnabled: template.isClickTrackingEnabled || false,
        carouselTemplates:
          template.carouselTemplates?.length > 0
            ? template.carouselTemplates
            : [{ ...DEFAULT_CAROUSEL_TEMPLATE }],

        carouselButtons:
          template.carouselButtons?.length > 0
            ? template.carouselButtons
            : [[]],

        carouselIndex: 0,

        carouselMediaType:
          template.carouselMediaType || "IMAGE",
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.templateFormat !== this.state.templateFormat) {
      const cursor = this.state.cursor;
      if (this.inputRef.current) {
        this.inputRef.current.setSelectionRange(cursor, cursor);
      }
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  extractParams = (e) => {
    if (this.state.templateCategory === "AUTHENTICATION") return;
    const prev = this.state.parameters;
    const params = [];
    const regx = /}}([0-9}]+){{/g;
    let curMatch;
    let format = e.target.value;
    let rev = format.split("").reverse().join("");

    while ((curMatch = regx.exec(rev))) {
      params.push(curMatch[0]);
    }

    //enforce sequence
    for (let i = 0; i < params.length; i++) {
      const revNum = `${i + 1}`.split("").reverse().join("");
      rev = rev.replace(params[params.length - i - 1], `}}${revNum}{{`);
    }

    format = rev.split("").reverse().join("");
    this.setState({
      templateFormat: format,
      parameters: params.map((e, idx) => (idx < prev.length ? prev[idx] : "")),
      cursor: e.target.selectionStart,
    });
  };

  setSampleURL = (e) => {
    const params = [];
    const regx = /{{([0-9}]+)}}/g;
    let curMatch;
    let hasCurly = false;
    while ((curMatch = regx.exec(this.state.templateCTAUrl))) {
      hasCurly = true;
    }

    const formattedURL = ((string, replacement) => {
      return string.replace(
        hasCurly ? /{{(\d+)}}/g : /\[.*?\]/g,
        function (match, g1) {
          return `[${replacement}]`;
        }
      );
    })(this.state.templateCTAUrl, e.target.value);

    this.setState({ templateCTAUrl: formattedURL });
  };

  handleParamsInput = (index, elem) => {
    const params = [...this.state.parameters];
    params[index] = elem.target.value;

    this.setState({
      parameters: params,
    });
  };

  handleAutoComplete = (fieldName, value, reason) => {
    if (reason === "select-option") {
      if (fieldName === "templateCategory") {
        if (value === "AUTHENTICATION") {
          const lang = "English";
          this.setState({
            templateCategory: value,
            templateLanguage: lang,
            templateType: "TEXT",
            templateName: "",
            templateFormat: AUTH_LANGUAGES[lang].templateFormat,
            templateHeader: "",
            templateFooter: "",
            templateMediaURL: "",
            templateCTAUrl: "",
            templateSample: "",
            templateHeaderType: "",
            ctaUrlParam: 0,
            parameters: [""],
            actionType: "All",
            buttons: [{ type: "COPY_CODE", subType: "COUPON_CODE", example: "" }],
            callToAction: [
              {
                type: "COPY_CODE",
                buttonTitle: AUTH_LANGUAGES[lang].copyCode,
                buttonValue: "",
              },
            ],
            quickReplies: [],
            codeExpiryMinutes: "",
            viewSecurityMessage: false,
            isClickTrackingEnabled: false,
            limitedTimeOffer: {},
            carouselTemplates: [],
            carouselButtons: [[]],
          });
        } else {
          this.setState({
            templateCategory: value,
            templateType: "",
            templateLanguage: "",
            templateName: "",
            templateFormat: "",
            templateHeader: "",
            templateFooter: "",
            templateMediaURL: "",
            templateCTAUrl: "",
            templateSample: "",
            templateHeaderType: "",
            ctaUrlParam: 0,
            parameters: [],
            actionType: "All",
            buttons: [],
            callToAction: [],
            quickReplies: [],
            codeExpiryMinutes: "",
            isClickTrackingEnabled: false,
            viewSecurityMessage: false,
            limitedTimeOffer: {},
            carouselTemplates: [],
            carouselButtons: [[]],
          });
        }
        return;
      }

      // Lock template type for AUTH
      if (fieldName === "templateType") {
        if (this.state.templateCategory === "AUTHENTICATION") return;

        const templateReset = {
          templateFormat: "",
          templateHeader: "",
          templateFooter: "",
          templateMediaURL: "",
          templateCTAUrl: "",
          templateSample: "",
          templateHeaderType: "",
          ctaUrlParam: 0,
          parameters: [],
          buttons: [],
          callToAction: [],
          quickReplies: [],
          isClickTrackingEnabled: false,
        };

        if (value === "CAROUSEL") {
          this.setState({
            ...templateReset,
            templateType: value,
            templateCategory: "MARKETING",
            actionType: "All",
            limitedTimeOffer: {},
            carouselTemplates: [{ ...DEFAULT_CAROUSEL_TEMPLATE }],
            carouselButtons: [[]],
            carouselIndex: 0,
          });
        } else if (value === "LIMITED_TIME_OFFER") {
          this.setState({
            ...templateReset,
            templateType: value,
            templateCategory: "MARKETING",
            actionType: "All",
            buttons: [{ type: "URL", text: "", url: "" }],
            limitedTimeOffer: { text: "", has_expiration: false },
            carouselTemplates: [],
            carouselButtons: [[]],
            carouselIndex: 0,
          });
        } else {
          this.setState({
            ...templateReset,
            templateType: value,
            actionType: "All",
            limitedTimeOffer: {},
            carouselTemplates: [],
            carouselButtons: [[]],
            carouselIndex: 0,
          });
        }
        return;
      }

      if (fieldName === "templateLanguage" && this.state.templateCategory === "AUTHENTICATION") {
        const langConfig = AUTH_LANGUAGES[value] || AUTH_LANGUAGES["English"];
        this.setState({
          templateLanguage: value,
          templateFormat: langConfig.templateFormat,
          callToAction: [
            {
              type: "COPY_CODE",
              buttonTitle: langConfig.copyCode,
              buttonValue: "",
            },
          ],
        });
        return;
      }

      this.setState({ [fieldName]: value });
    }
  };

  handleRadioInput = (e) => {
    this.setState({
      actionType: e.target.value,
      callToAction:
        e.target.value === "CAT"
          ? [{ type: "", buttonValue: "", buttonTitle: "" }]
          : [],
      quickReplies: e.target.value === "QuickReplies" ? [""] : [],
      buttons: [],
      ctaUrlParam: 0,
      templateCTAUrl: "",
      isClickTrackingEnabled: false,
    });
  };

  catAutoComplete = (index, value, reason, isExtension) => {
    if (reason !== "select-option") return;

    if (this.state.actionType === "All") {
      const buttons = [...this.state.buttons];
      if (isExtension) {
        buttons[index] = { ...buttons[index], extension: value.replace(/^\+/, "") };
      }
      this.setState({ buttons });
      return;
    }

    const callToAction = [...this.state.callToAction];
    if (isExtension) {
      callToAction[index] = { ...callToAction[index], extension: value.replace(/^\+/, "") };
    } else {
      callToAction[index] = { ...callToAction[index], type: value };

      if (value === "URL") {
        this.setState({
          ctaUrlParam: (
            callToAction[index]["buttonValue"].match(/\{\{[0-9]+\}\}/g) || []
          ).length,
        });
      } else if (index === 0) {
        this.setState({
          ctaUrlParam: 0,
          templateCTAUrl: "",
          isClickTrackingEnabled: false,
        });
      }
    }
    this.setState({ callToAction });
  };

  catInput = (index, elem) => {
    const value = elem.target.value;

    if (this.state.actionType === "All") {
      const buttons = [...this.state.buttons];
      buttons[index] = { ...buttons[index] };

      if (elem.target.name === "buttonValue") {
        if (buttons[index].type === "URL") {
          const params = [];
          const regx = /{{([0-9}]+)}}/g;
          let curMatch;
          let format = value;
          while ((curMatch = regx.exec(format))) params.push(curMatch[0]);
          for (let i = 0; i < params.length; i++) {
            format = format.replace(params[i], `{{${i + 1}}}`);
          }
          buttons[index].url = format;
        } else {
          buttons[index].number = value;
        }
      } else if (buttons[index].type === "COPY_CODE") {
        buttons[index].example = value;
      } else {
        buttons[index].text = value;
      }
      this.setState({ buttons });
      return;
    }

    const callToAction = [...this.state.callToAction];
    callToAction[index] = { ...callToAction[index] };
    callToAction[index][elem.target.name] = value;
    if (
      elem.target.name === "buttonValue" &&
      callToAction[index].type === "URL"
    ) {
      const params = [];
      const regx = /{{([0-9}]+)}}/g;
      let curMatch;
      let format = value;

      while ((curMatch = regx.exec(format))) {
        params.push(curMatch[0]);
      }

      for (let i = 0; i < params.length; i++) {
        format = format.replace(params[i], `{{${i + 1}}}`);
      }

      callToAction[index].buttonValue = format;

      this.setState({
        ctaUrlParam: (value.match(/\{\{[0-9]+\}\}/g) || []).length,
      });
    }
    this.setState({ callToAction });
  };

  quickReplyInput = (index, elem) => {
    if (this.state.actionType === "All") {
      let value = elem.target.value.trimStart();
      if (value.length > 0 && value.trim() === "") return;
      const buttons = this.state.buttons.map((btn, i) =>
        i === index ? { ...btn, text: value } : btn
      );
      this.setState({ buttons });
      return;
    }

    const quickReplies = [...this.state.quickReplies];
    quickReplies[index] = elem.target.value;
    this.setState({ quickReplies });
  };

  addQuickReply = () => {
    const quickReplies = [...this.state.quickReplies, ""];
    this.setState({ quickReplies });
  };

  removeQuickReply = (index) => {
    let quickReplies = [...this.state.quickReplies];
    quickReplies = quickReplies.filter((_, i) => i !== index);
    this.setState({ quickReplies });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  setCarouselMediaType = (type) => {
    this.setState({ carouselMediaType: type });
  };

  handleLtoText = (e) => {
    const text = e.target.value.substring(0, 16);
    this.setState({ limitedTimeOffer: { ...this.state.limitedTimeOffer, text } });
  };

  setCarouselIndex = (value) => {
    this.setState({ carouselIndex: Math.max(0, Math.min(value, 9)) });
  };

  addCarouselTemplate = (index) => {
    this.setState((prevState) => {
      const carouselTemplates = [...prevState.carouselTemplates];
      const carouselButtons = [...prevState.carouselButtons];

      // Clone button structure from card 0
      const initialButtons = (carouselButtons[0] || []).map((btn) => {
        if (btn.type === "URL") return { type: "URL", text: "", url: "" };
        if (btn.type === "QUICK_REPLY") return { type: "QUICK_REPLY", text: "" };
        if (btn.type === "PHONE_NUMBER") return { type: "PHONE_NUMBER", text: "", phone_number: "", number: "", extension: "" };
        if (btn.type === "COPY_CODE") return { type: "COPY_CODE", subType: "COUPON_CODE", example: "" };
        return { ...btn };
      });

      carouselTemplates.splice(index, 0, { ...DEFAULT_CAROUSEL_TEMPLATE });
      carouselButtons.splice(index, 0, initialButtons);

      return { carouselTemplates, carouselButtons, carouselIndex: index };
    });
  };

  deleteCarouselTemplate = () => {
    this.setState((prevState) => {
      const { carouselTemplates, carouselIndex, carouselButtons } = prevState;
      if (carouselTemplates.length <= 1) return null; // min 1 card
      const updatedTemplates = [...carouselTemplates];
      const updatedButtons = [...carouselButtons];
      updatedTemplates.splice(carouselIndex, 1);
      updatedButtons.splice(carouselIndex, 1);
      return {
        carouselTemplates: updatedTemplates,
        carouselButtons: updatedButtons,
        carouselIndex: Math.max(carouselIndex - 1, 0),
      };
    });
  };

  updateCarousel = (updatedFields) => {
    this.setState((prevState) => {
      const updated = prevState.carouselTemplates.map((card, idx) =>
        idx === prevState.carouselIndex
          ? {
            ...card,
            ...updatedFields,
            parameters: updatedFields.parameters
              ? [...updatedFields.parameters]
              : [...(card.parameters || [])],
          }
          : { ...card }
      );

      return {
        carouselTemplates: updated,
      };
    });
  };

  handleCarouselBodyInput = (e) => {
    const value = e.target.value;
    const prev = this.state.carouselTemplates[this.state.carouselIndex]?.parameters || [];
    const params = [];
    const regx = /}}([0-9}]+){{/g;
    let curMatch;
    let format = value;
    let rev = format.split("").reverse().join("");

    while ((curMatch = regx.exec(rev))) {
      params.push(curMatch[0]);
    }
    for (let i = 0; i < params.length; i++) {
      const revNum = `${i + 1}`.split("").reverse().join("");
      rev = rev.replace(params[params.length - i - 1], `}}${revNum}{{`);
    }
    format = rev.split("").reverse().join("");
    this.updateCarousel({
      templateFooter: format,
      parameters: params.map((_, idx) => (idx < prev.length ? prev[idx] : "")),
    });
  };

  handleCarouselParamsInput = (index, elem) => {
    const parameters = [
      ...(this.state.carouselTemplates[this.state.carouselIndex]?.parameters || []),
    ];
    parameters[index] = elem.target.value;
    this.updateCarousel({ parameters });
  };

  addCarouselButton = (btnType) => {
    this.setState((prevState) => {
      const { carouselButtons, carouselIndex } = prevState;
      const updated = carouselButtons.map((cardBtns, idx) => {
        const btns = [...cardBtns];
        if (btns.length >= 2) return btns;
        let newBtn;
        if (btnType === "URL") newBtn = { type: "URL", text: "", url: "" };
        else if (btnType === "QUICK_REPLY") newBtn = { type: "QUICK_REPLY", text: "" };
        else if (btnType === "PHONE_NUMBER") newBtn = { type: "PHONE_NUMBER", text: "", phone_number: "", number: "", extension: "" };
        else if (btnType === "COPY_CODE") newBtn = { type: "COPY_CODE", subType: "COUPON_CODE", example: "" };
        else return btns;
        btns.push(newBtn);
        return btns;
      });
      return { carouselButtons: updated };
    });
  };

  removeCarouselButton = (btnIndex) => {
    this.setState((prevState) => {
      const removedType = (prevState.carouselButtons[0] || [])[btnIndex]?.type;
      const updated = prevState.carouselButtons.map((cardBtns) =>
        cardBtns.filter((_, i) => i !== btnIndex)
      );
      const stillHasUrl = (updated[0] || []).some((b) => b.type === "URL");
      const updateState = { carouselButtons: updated };
      if (prevState.isClickTrackingEnabled && removedType === "URL" && !stillHasUrl) {
        updateState.isClickTrackingEnabled = false;
      }
      return updateState;
    });
  };

  carouselButtonInput = (btnIndex, elem) => {
    const value = elem.target.value;
    const name = elem.target.name;
    this.setState((prevState) => {
      const { carouselButtons, carouselIndex } = prevState;
      const updated = [...carouselButtons];
      const cardBtns = [...updated[carouselIndex]];
      cardBtns[btnIndex] = { ...cardBtns[btnIndex] };

      if (name === "buttonValue") {
        if (cardBtns[btnIndex].type === "URL") {
          let format = value;
          const params = [];
          const regx = /{{([0-9}]+)}}/g;
          let curMatch;
          while ((curMatch = regx.exec(format))) params.push(curMatch[0]);
          for (let i = 0; i < params.length; i++) format = format.replace(params[i], `{{${i + 1}}}`);
          cardBtns[btnIndex].url = format;
        } else {
          cardBtns[btnIndex].number = value;
        }
      } else if (cardBtns[btnIndex].type === "COPY_CODE") {
        cardBtns[btnIndex].example = value;
      } else {
        cardBtns[btnIndex].text = value;
      }

      updated[carouselIndex] = cardBtns;
      return { carouselButtons: updated };
    });
  };

  carouselButtonExtension = (btnIndex, value) => {
    this.setState((prevState) => {
      const { carouselButtons, carouselIndex } = prevState;
      const updated = [...carouselButtons];
      const cardBtns = [...updated[carouselIndex]];
      cardBtns[btnIndex] = { ...cardBtns[btnIndex], extension: value.replace(/^\+/, "") };
      updated[carouselIndex] = cardBtns;
      return { carouselButtons: updated };
    });
  };

  handleLtoExpirationToggle = (e) => {
    const has_expiration = e.target.checked;
    const limitedTimeOffer = { ...this.state.limitedTimeOffer, has_expiration };
    const buttons = [...this.state.buttons];

    if (has_expiration) {
      if (!buttons.some((b) => b.type === "COPY_CODE")) {
        buttons.unshift({ type: "COPY_CODE", subType: "COUPON_CODE", example: "SAMPLE" });
      }
    } else {
      const filtered = buttons.filter((b) => b.type !== "COPY_CODE");
      this.setState({ limitedTimeOffer, buttons: filtered });
      return;
    }

    this.setState({ limitedTimeOffer, buttons });
  };

  addNewButton = (buttonType) => {
    const buttonPrecedence = { QUICK_REPLY: 0, PHONE_NUMBER: 1, URL: 2, COPY_CODE: 3 };
    let newButton;
    switch (buttonType) {
      case "QUICK_REPLY":
        newButton = { type: "QUICK_REPLY", text: "" };
        break;
      case "URL":
        newButton = { type: "URL", text: "", url: "" };
        break;
      case "PHONE_NUMBER":
        newButton = { type: "PHONE_NUMBER", text: "", phone_number: "", number: "", extension: "" };
        break;
      case "COPY_CODE":
        newButton = { type: "COPY_CODE", subType: "COUPON_CODE", example: "" };
        break;
      default:
        return;
    }
    const newButtons = [...this.state.buttons, newButton];
    newButtons.sort((a, b) => (buttonPrecedence[b.type] ?? -1) - (buttonPrecedence[a.type] ?? -1));
    this.setState({ buttons: newButtons });
  };

  removeButtons = (index) => {
    let buttons = [...this.state.buttons];
    const button = buttons[index];
    buttons = buttons.filter((_, i) => i !== index);
    const updateState = { buttons };
    if (
      this.state.isClickTrackingEnabled &&
      ["url", "URL"].includes(button.type)
    ) {
      if (!buttons.some((e) => ["url", "URL"].includes(e.type))) {
        updateState.isClickTrackingEnabled = false;
      }
    }
    this.setState(updateState);
  };

  generateButtons = (buttons) => {
    return buttons.map((btn) => {
      if (btn.type === "URL") {
        const urlParams = (btn.url || "").match(/\{\{[0-9]+\}\}/g) || [];
        const generated = { type: "URL", text: btn.text, url: btn.url || "" };
        if (urlParams.length > 0) {
          const normalizedUrl = (btn.url || "").replace(
            /\{\{[0-9]+\}\}/g,
            "{{1}}"
          );
          generated.url = normalizedUrl;
          generated.example = [normalizedUrl.replace(/\{\{1\}\}/, "events")];
        }
        return generated;
      }
      if (btn.type === "PHONE_NUMBER") {
        return {
          type: "PHONE_NUMBER",
          text: btn.text,
          phone_number: (btn.extension || "") + (btn.number || ""),
          phoneMetadata: { extension: btn.extension || "", number: btn.number || "" },
        };
      }
      if (btn.type === "COPY_CODE") {
        return { type: "COPY_CODE", subType: "COUPON_CODE", example: btn.example || "" };
      }
      // QUICK_REPLY
      return { type: "QUICK_REPLY", text: btn.text };
    });
  };

  addCAT = () => {
    const newAction = { type: "", buttonValue: "", buttonTitle: "" };
    const callToAction = this.state.callToAction;
    this.setState({ callToAction: [...callToAction, newAction] });
  };

  removeCAT = (index) => {
    let callToAction = [...this.state.callToAction];
    let ctaUrlParam = this.state.ctaUrlParam;
    if (callToAction[index].type === "URL") ctaUrlParam = 0;
    callToAction = callToAction.filter((e, i) => i !== index);
    this.setState({ callToAction, templateCTAUrl: "", ctaUrlParam });
  };

  validateName = (e) => {
    let name = e.target.value;
    const snackbar = { message: "", open: false };
    if (name) {
      const lastChar = name[name.length - 1];
      const isAlphanumeric = (string) => /[^A-Za-z0-9_]/.test(string);
      if (isAlphanumeric(lastChar)) {
        snackbar.message =
          "Only lower case alphabets, numbers and underscore is allowed for this field";
        snackbar.open = true;
        name = name.substring(0, name.length - 1);
      }
    }
    this.setState({ templateName: name.toLowerCase(), snackbar });
  };

  validateTemplate = () => {
    const t = this.state;
    const validBracePattern = /\{\{[0-9]+\}\}/g;
    const validTextPattern = /^[a-zA-Z0-9].*$/; // string starting with alphabet & non-empty
    const buttonTextPattern = /^(?!\s*$).{0,25}$/; // string with atleast non-space character, maxlength 25
    const alphanumericPattern = /^[a-z0-9_][a-z0-9_]*$/; // string starting with alphanumeric & non-empty
    const validNumberPattern = /^\d+$/;

    if (t.templateCategory === "AUTHENTICATION") {
      if (!alphanumericPattern.test(t.templateName)) {
        return {
          valid: false,
          msg: "Template name is required field, only alphanumeric characters & underscores without spaces are allowed.",
        };
      }

      if (!LANGUAGES.some((e) => e === t.templateLanguage)) {
        return { valid: false, msg: "Select template language" };
      }

      if (!t.parameters[0] || !t.parameters[0].trim()) {
        return { valid: false, msg: "Sample value for {{1}} is required." };
      }

      const authResult = templateMsgHelper.validateAuthenticationTemplate(
        t.templateType,
        t.codeExpiryMinutes,
        t.viewSecurityMessage,
        t.buttons
      );
      if (!authResult.valid) {
        return authResult;
      }

      return { valid: true };
    }

    if (!TEMPLATE_CATEGORIES.some((e) => e === t.templateCategory)) {
      return { valid: false, msg: "Select template category" };
    }
    if (!MSG_TYPES.some((e) => e.type === t.templateType)) {
      return { valid: false, msg: "Select template type" };
    }
    if (!LANGUAGES.some((e) => e === t.templateLanguage)) {
      return { valid: false, msg: "Select template language" };
    }
    if (!alphanumericPattern.test(t.templateName)) {
      return {
        valid: false,
        msg: "Template name is required field, only alphanumeric characters & underscores without spaces are allowed.",
      };
    }

    // check header for length
    if (t.templateHeader) {
      if (t.templateHeader.length > 60) {
        return {
          valid: false,
          msg: "Template header length over 60 characters.",
        };
      }
      //check if header contains params
      if (t.templateHeader.match(validBracePattern)) {
        return {
          valid: false,
          msg: "Template header cannot contain paramters",
        };
      }
    }

    //check footer doesn't exceed char limit
    if (t.templateFooter) {
      if (t.templateFooter.length > 60) {
        return {
          valid: false,
          msg: "Template footer length over 60 characters.",
        };
      }
      //check if footer contains params
      if (t.templateFooter.match(validBracePattern)) {
        return {
          valid: false,
          msg: "Template footer cannot contain paramters",
        };
      }
    }
    if (!t.templateFormat) {
      return { valid: false, msg: "Template format is required field" };
    }

    const result = templateMsgHelper.validateFormat(t.templateFormat, "format");
    if (!result.valid) {
      return result;
    }

    for (const params of t.parameters) {
      if (!params)
        return {
          valid: false,
          msg: "Please provide sample values for all the paramters",
        };
    }

    if (
      t.templateType !== "TEXT" &&
      t.templateType !== "LOCATION" &&
      t.templateType !== "LIMITED_TIME_OFFER" &&
      t.templateType !== "CAROUSEL"
    ) {
      if (!t.templateMediaURL) {
        return {
          valid: false,
          msg: `Sample media URL is required for template type ${t.templateType}`,
        };
      }
      if (!templateMsgHelper.validateUrl(t.templateMediaURL)) {
        return {
          valid: false,
          msg: `Invalid Sample media URL`,
        };
      }
    }

    // validate interactive actions
    if (t.templateName === "shopify_cod_order_confirmation") {
      if (t.quickReplies.length !== 2) {
        return { valid: false, msg: "Need two quick reply" };
      }
    }
    if (t.actionType === "QuickReplies") {
      if (t.quickReplies.length === 0) {
        return { valid: false, msg: "Need atleast one quick reply" };
      }
      const isNotValid = t.quickReplies.some((e) => !buttonTextPattern.test(e)); // check for empty quick reply
      if (isNotValid) {
        return {
          valid: false,
          msg: "Quick replies must be non-empty & max 25 characters with spaces are allowed.",
        };
      }
      const uniqueSet = new Set(t.quickReplies.map((i) => i.trim()));
      if (t.quickReplies.length !== uniqueSet.size)
        return {
          valid: false,
          msg: "Each Quick Reply button must have unique text.",
        };
    }
    if (t.actionType === "CAT") {
      const uniqueSet = new Set(
        t.callToAction.map((i) => i.buttonTitle.trim())
      );
      if (t.callToAction.length !== uniqueSet.size)
        return {
          valid: false,
          msg: "Each Call-To-Action button must have unique text.",
        };
      if (this.state.ctaUrlParam > 1) {
        return { valid: false, msg: "Only one param allowed in CTA URL" };
      }
      if (t.callToAction.length === 0) {
        return { valid: false, msg: "Need atleast one call to action button" };
      }
      const isNotValid = t.callToAction.some((e) => {
        if (e.type === "Phone Number") {
          return (
            !validTextPattern.test(e.type) ||
            !buttonTextPattern.test(e.buttonTitle) ||
            !validNumberPattern.test(e.buttonValue)
          );
        }
        if (e.type === "URL") {
          return (
            !validTextPattern.test(e.type) ||
            !buttonTextPattern.test(e.buttonTitle) ||
            !templateMsgHelper.validateUrl(e.buttonValue)
          );
        }
        return true;
      });
      if (isNotValid) {
        return { valid: false, msg: "Call to action field invalid" };
      }
      const interativeURLAction = t.callToAction.find((e) => e.type === "URL");
      if (interativeURLAction && this.state.ctaUrlParam > 0) {
        if (!t.templateCTAUrl) {
          return {
            valid: false,
            msg: "Sample CTA URL is necessery for URL type actions.",
          };
        }
        if (!templateMsgHelper.validateUrl(t.templateCTAUrl)) {
          return {
            valid: false,
            msg: "Invalid Sample CTA URL.",
          };
        }
        const compare = templateMsgHelper.compareFormatAndSample(
          interativeURLAction.buttonValue,
          t.templateCTAUrl
        );
        if (!compare.valid) {
          return {
            valid: false,
            msg: "Sample action URL doesn't match with template URL format",
          };
        }
        const bodyParamCount = (
          this.state.templateFormat.match(/\{\{[0-9]+\}\}/g) || []
        ).length;
        const ctaDynamicParam =
          interativeURLAction.buttonValue.match(/\{\{[0-9]+\}\}/g) || [];
        if (ctaDynamicParam.length) {
          if (!ctaDynamicParam[0].includes(1)) {
            return {
              valid: false,
              msg: "Invalid parameter in dynamic CTA URL",
            };
          }
        }
      }
    }
    if (t.actionType === "All") {
      if (t.templateType === "CAROUSEL") {
        if (t.carouselTemplates.length === 0) {
          return { valid: false, msg: "Add at least one carousel card." };
        }
        // Ensure at least one button is added for carousel cards
        const firstCardButtons = t.carouselButtons[0] || [];
        if (firstCardButtons.length === 0) {
          return {
            valid: false,
            msg: "At least one button is mandatory for carousel cards.",
          };
        }
        // Validate button types from card 0 (types are consistent across all cards)
        const carouselBtnResult = templateMsgHelper.validateButtons(
          this.generateButtons(t.carouselButtons[0] || []),
          t.templateCategory
        );
        if (!carouselBtnResult.valid) return carouselBtnResult;

        // Validate each Carousel card body format and sample parameters
        for (let i = 0; i < t.carouselTemplates.length; i++) {
          const card = t.carouselTemplates[i];
          if (card.templateFooter) {
            const formatResult = templateMsgHelper.validateFormat(
              card.templateFooter,
              `Card ${i + 1} Body`
            );
            if (!formatResult.valid) return formatResult;
          }

          if (card.parameters && card.parameters.length > 0) {
            for (let j = 0; j < card.parameters.length; j++) {
              if (!card.parameters[j] || !card.parameters[j].trim()) {
                return {
                  valid: false,
                  msg: `Please provide sample values for all parameters in Card ${i + 1}`,
                };
              }
            }
          }
        }
      } else {
        const formattedButtons = this.generateButtons(t.buttons);
        const btnResult = templateMsgHelper.validateButtons(
          formattedButtons,
          t.templateCategory
        );
        if (!btnResult.valid) {
          return btnResult;
        }
      }
    }

    if (t.templateType === "LIMITED_TIME_OFFER") {
      if (!t.templateHeaderType) {
        return { valid: false, msg: "Please select a Header Media Type for the Limited Time Offer." };
      }
      const ltoResult = templateMsgHelper.validateLimitedTimeOffer(
        t.limitedTimeOffer,
        t.buttons,
        t.templateCategory
      );
      if (!ltoResult.valid) {
        return ltoResult;
      }
    }

    return { valid: true, msg: "All fields are validated" };
  };

  autoFillAndSubmit = () => {
    //  Fill sample CTA and Media URLS
    const { type } = this.props.partner || {};
    const { templateType, callToAction, ctaUrlParam } = this.state;
    const interativeURLAction = callToAction.find((e) => e.type === "URL");

    const sampleMediaUrl =
      templateType === "IMAGE"
        ? "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-image.png"
        : templateType === "VIDEO"
          ? "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-video.mp4"
          : templateType === "FILE"
            ? "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-doc.pdf"
            : templateType === "LIMITED_TIME_OFFER"
              ? this.state.templateHeaderType === "VIDEO"
                ? "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-video.mp4"
                : "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-image.png"
              : "";

    const sampleCTAUrl =
      interativeURLAction && ctaUrlParam > 0
        ? interativeURLAction.buttonValue.replace(
          /\{\{[0-9]+\}\}/g,
          (match) => "[events]"
        )
        : "";

    this.setState(
      {
        templateMediaURL: sampleMediaUrl,
        templateCTAUrl: sampleCTAUrl,
      },
      this.onSubmit
    );
  };

  generateTemplate = () => {
    let formattedString = this.state.templateFormat;
    const formattedSampleMsg = ((string, replacementArray) => {
      return string.replace(/{{(\d+)}}/g, function (match, g1) {
        return `[${replacementArray[g1 - 1]}]`;
      });
    })(this.state.templateFormat, this.state.parameters);

    if (this.state.templateCategory === "AUTHENTICATION") {
      let finalMessage = formattedString.replace(
        /{{(\d+)}}/g,
        `[${this.state.parameters[0] || "123456"}]`
      );

      const langConfig = AUTH_LANGUAGES[this.state.templateLanguage] || AUTH_LANGUAGES["English"];
      let finalFormat = formattedString;
      let finalFooter = this.state.templateFooter;

      if (this.state.viewSecurityMessage) {
        finalMessage += " " + langConfig.securityText;
        finalFormat += " " + langConfig.securityText;
      }

      if (this.state.codeExpiryMinutes) {
        finalFooter = langConfig.codeExpirationWarning.replace("<>", this.state.codeExpiryMinutes);
      }

      return {
        assistantId: this.props.match.params.projectId,
        label: this.state.templateName,
        category: this.state.templateCategory,
        type: this.state.templateType,
        language: this.state.templateLanguage,
        name: this.state.templateName,
        format: finalFormat,
        sampleMessage: finalMessage,
        actionType: this.state.actionType,
        callToAction: this.state.callToAction,
        quickReplies: this.state.quickReplies,
        sampleMediaUrl: this.state.templateMediaURL,
        sampleCTAUrl: this.state.templateCTAUrl,
        headerText: this.state.templateHeader,
        footerText: finalFooter,
        viewSecurityMessage: this.state.viewSecurityMessage,
        codeExpiryMinutes: this.state.codeExpiryMinutes,
      };
    }

    return {
      assistantId: this.props.match.params.projectId,
      label: this.state.templateName,
      category: this.state.templateCategory,
      type: this.state.templateType,
      language: this.state.templateLanguage,
      name: this.state.templateName,
      format: formattedString,
      sampleMessage: formattedSampleMsg,
      actionType: this.state.actionType,
      callToAction: this.state.callToAction,
      quickReplies: this.state.quickReplies,
      sampleMediaUrl: this.state.templateMediaURL,
      sampleCTAUrl: this.state.templateCTAUrl,
      headerText: this.state.templateHeader,
      footerText: this.state.templateFooter,
      headerType: this.state.templateHeaderType || undefined,
    };
  };

  onSubmit = () => {
    const assistantId = this.props.match.params.projectId;
    const result = this.validateTemplate();
    const { onComplete } = this.props;

    if (!result.valid) {
      this.setState({ success: false, err: result.msg });
      return;
    } else {
      const t = this.state;
      this.setState({ err: "", isSubmitting: true, success: false });
      const generatedTemplate = this.generateTemplate();

      let payload;

      // Remap generateTemplate() keys to what the backend expects
      const {
        format,
        sampleMessage,
        actionType,
        callToAction: genCallToAction,
        quickReplies: genQuickReplies,
        ...rest
      } = generatedTemplate;

      const basePayload = {
        ...rest,
        text: format,
        sample_text: sampleMessage,
        message_action_type: actionType,
        quick_replies: genQuickReplies,
      };

      if (t.templateCategory === "AUTHENTICATION") {
        const copyCodeBtn = (t.buttons || []).find((b) => b.type === "COPY_CODE");
        payload = {
          ...basePayload,
          buttons: [
            {
              type: "COPY_CODE",
              subType: "COUPON_CODE",
              example: copyCodeBtn?.example || "",
            },
          ],
          call_to_action: [],
          isClickTrackingEnabled: false,
          templateParams: t.parameters,
        };
      } else if (t.templateType === "CAROUSEL") {
        const carousel_cards = t.carouselTemplates.map((card, idx) => {
          const components = [];
          components.push({
            type: "HEADER",
            format: t.carouselMediaType || "IMAGE",
            example: {
              header_handle: [
                (t.carouselMediaType || "IMAGE") === "VIDEO"
                  ? "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-video.mp4"
                  : "https://aisensy-demo-media.s3.ap-south-1.amazonaws.com/demo-image.png",
              ],
            },
          });
          if (card.templateFooter && card.templateFooter.trim()) {
            const bodyComp = { type: "BODY", text: card.templateFooter };
            if (card.parameters && card.parameters.length > 0) {
              bodyComp.example = { body_text: [card.parameters] };
            }
            components.push(bodyComp);
          }
          const cardBtns = t.carouselButtons[idx] || [];
          if (cardBtns.length > 0) {
            components.push({
              type: "BUTTONS",
              buttons: cardBtns.map((btn) => {
                if (btn.type === "QUICK_REPLY") return { type: "QUICK_REPLY", text: btn.text || "" };
                if (btn.type === "URL") return { type: "URL", text: btn.text || "", url: btn.url || "" };
                if (btn.type === "PHONE_NUMBER") return { type: "PHONE_NUMBER", text: btn.text || "", phone_number: (btn.extension || "") + (btn.number || "") };
                return { type: btn.type, text: btn.text || "" };
              }),
            });
          }
          return { components };
        });
        payload = {
          ...basePayload,
          carousel_cards,
          buttons: [],
          call_to_action: [],
          isClickTrackingEnabled: t.isClickTrackingEnabled,
          templateParams: t.parameters,
        };
      } else if (t.actionType === "All") {
        payload = {
          ...basePayload,
          buttons: this.generateButtons(t.buttons),
          call_to_action: [],
          isClickTrackingEnabled: t.isClickTrackingEnabled,
          templateParams: t.parameters,
          ...(t.templateType === "LIMITED_TIME_OFFER" && t.limitedTimeOffer?.text
            ? { limitedTimeOffer: t.limitedTimeOffer }
            : {}),
        };
      } else {
        // Legacy CAT / QuickReplies / None
        const callToActionBtns = JSON.parse(
          JSON.stringify(genCallToAction)
        );
        for (let i = 0; i < callToActionBtns.length; i++) {
          if (
            callToActionBtns[i].type === "Phone Number" &&
            callToActionBtns[i].extension
          ) {
            callToActionBtns[i].buttonValue =
              callToActionBtns[i].extension + callToActionBtns[i].buttonValue;
          }
        }

        payload = {
          ...basePayload,
          buttons: t.buttons,
          call_to_action: callToActionBtns.sort((a, b) =>
            a.type < b.type ? -1 : 1
          ),
          sampleCTAUrl: t.ctaUrlParam > 0 ? t.templateCTAUrl : "",
          isClickTrackingEnabled: t.isClickTrackingEnabled,
          templateParams: t.parameters,
        };
      }

      const isDirectAPI = this.props.partner?.type === "DIRECT";

      if (isDirectAPI) {
        payload.isClickTrackingEnabled = false;
        payload.projectId = assistantId;
      }

      const interativeURLAction = (payload.call_to_action || []).find(
        (e) => e.type === "URL"
      );

      const targetURL = isDirectAPI
        ? URL + "/api/direct-api-partner/templates"
        : projectURL + `/project/${assistantId}/wa_template`;

      axios
        .post(targetURL, payload)
        .then((response) => {
          let reduxPayload;
          if (isDirectAPI) {
            reduxPayload = { ...response.data, templateLanguage: this.state.templateLanguage };
          } else {
            reduxPayload = {
              ...response.data,
              assistantName: response.data.assistant_name,
              _id: response.data.id,
            };
          }
          this.props.createnewTemplate(reduxPayload);
          this.setState({
            err: "",
            isSubmitting: false,
            success: true,
            templateCTAUrl: interativeURLAction
              ? interativeURLAction.buttonValue
              : "",
          });
          this.props.callSnackbar("success", "Template submit successful");
          this.props.close();
          typeof onComplete === "function" &&
            onComplete(this.state.templateName, this.state.templateType);
        })
        .catch((error) => {
          const errMsg =
            error?.response?.data?.message ||
            error?.response?.data?.errorMessage ||
            error?.message ||
            "Something went wrong, try again";
          this.setState({
            err: errMsg,
            isSubmitting: false,
            success: false,
            templateCTAUrl: interativeURLAction
              ? interativeURLAction.buttonValue
              : "",
            alertMsg: errMsg,
            alertType: "error",
          });
        });
    }
  };

  onSnackbarClose = () => {
    this.setState({
      alertType: "",
      alertMsg: "",
    });
  };


  render() {
    const {
      classes,
      inDialog,
      template,
      showDialog,
      toggleDialog,
      isSubmitted,
    } = this.props;

    const { projectId } = this.props.match.params;
    const activePlan = this.props.activePlan || (this.props.assistants?.[projectId] || {}).activePlan || "";
    const interativeURLAction = this.state.callToAction.find(
      (e) => e.type === "URL"
    );
    return (
      <Box
        className={classes.root}
        py={{ xs: 2, md: inDialog ? 0 : 8 }}
        px={{ xs: 2, md: inDialog ? 2 : 6 }}
      >
        <Box my={3}>
          <Grid container spacing={6} justify="space-between">
            <Grid item xs={12} md={6} container>
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Template Category
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Your template should fall under one of these categories.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  disableClearable
                  options={TEMPLATE_CATEGORIES.map((option) => option)}
                  onChange={(e, value, reason) =>
                    this.handleAutoComplete("templateCategory", value, reason)
                  }
                  value={this.state.templateCategory}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.textField}
                      InputProps={{ ...params.InputProps }}
                      placeholder="Select message categories"
                      name="categories"
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} container>
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Template Language
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  You will need to specify the language in which message
                  template is submitted.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  disableClearable
                  options={LANGUAGES.map((option) => option)}
                  onChange={(e, value, reason) =>
                    this.handleAutoComplete("templateLanguage", value, reason)
                  }
                  value={this.state.templateLanguage}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.textField}
                      InputProps={{ ...params.InputProps }}
                      placeholder="Select message language"
                      name="language"
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={6} justify="space-between">
          <Grid item xs={12} md={6} container>
            {/* template name*/}
            <Box width="100%">
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Template Name
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Name can only be in lowercase alphanumeric characters and
                  underscores. Special characters and white-space are not
                  allowed
                  <br /> e.g. - app_verification_code
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="templateName"
                  className={classes.textArea}
                  placeholder="Enter name"
                  onChange={this.validateName}
                  value={this.state.templateName}
                  disabled={inDialog}
                />
              </Grid>
            </Box>
            {/* HEADER */}
            <Box my={6} width="100%">
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Template Type
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Your template type should fall under one of these categories.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  disableClearable
                  disabled={this.state.templateCategory === "AUTHENTICATION"}
                  options={
                    this.state.templateCategory === "AUTHENTICATION"
                      ? ["TEXT"]
                      : MSG_TYPES.map((option) => option.type)
                  }
                  onChange={(e, value, reason) => {
                    this.setState({
                      templateMediaURL: "",
                      templateHeader: "",
                      templateHeaderType: "",
                    });
                    this.handleAutoComplete("templateType", value, reason);
                  }}
                  value={this.state.templateType}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.textField}
                      InputProps={{ ...params.InputProps }}
                      placeholder="Select message type"
                    />
                  )}
                />
                {this.state.templateType === "LIMITED_TIME_OFFER" && (
                  <Box mt={6}>
                    <Grid item xs={12} style={{ marginBottom: "8px" }}>
                      <Typography variant="h4" gutterBottom>
                        Header Media Type
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                        Choose the media type for the Limited Time Offer header.
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        disableClearable
                        options={["IMAGE", "VIDEO"]}
                        onChange={(e, value, reason) =>
                          this.handleAutoComplete("templateHeaderType", value, reason)
                        }
                        value={this.state.templateHeaderType || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className={classes.textField}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select header media type"
                          />
                        )}
                      />
                    </Grid>
                  </Box>
                )}
                {this.state.templateCategory !== "AUTHENTICATION" &&
                  this.state.templateType === "TEXT" && (
                    <Box mt={6}>
                      <Grid item xs={12}>
                        <Typography variant="h4" gutterBottom>
                          Template Header Text{" "}
                          <span className={classes.optional}>(Optional)</span>
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          gutterBottom
                        >
                          Header text is optional and only upto 60 characters are
                          allowed.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          name="templateHeader"
                          className={classes.textArea}
                          placeholder="Enter header text here"
                          inputProps={{ maxLength: 60 }}
                          FormHelperTextProps={{
                            className: classes.characterCounter,
                          }}
                          helperText={
                            this.state.templateHeader &&
                            `${this.state.templateHeader.length}/60`
                          }
                          onChange={this.handleInput}
                          value={this.state.templateHeader}
                          disabled={inDialog}
                          style={{ marginTop: "8px" }}
                        />
                      </Grid>
                    </Box>
                  )
                }
              </Grid>
            </Box>
            {/* body  */}
            {this.state.templateCategory !== "AUTHENTICATION" && (
              <Box mb={6} width="100%">
                <Grid container>
                  <Grid item xs={12} style={{ marginBottom: "8px" }}>
                    <Typography variant="h4" gutterBottom>
                      Template Format
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      gutterBottom
                    >
                      Use text formatting - *bold* , _italic_ & ~strikethrough~
                      <br />
                      Your message content. Upto 1024 characters are allowed.
                      <br /> e.g. - Hello {`{{1}}`}, your code will expire in{" "}
                      {`{{2}}`} mins.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      inputRef={this.inputRef}
                      multiline
                      rows={2}
                      rowsMax={20}
                      name="templateFormat"
                      className={classes.textArea}
                      placeholder="Enter your message in here..."
                      disabled={false}
                      value={this.state.templateFormat}
                      onChange={this.extractParams}
                      inputProps={{ maxLength: 1024 }}
                      FormHelperTextProps={{
                        className: classes.characterCounter,
                      }}
                      helperText={`${this.state.templateFormat.length}/1024`}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}

            {this.state.parameters.length > 0 && (
              <Box mb={6}>
                <Grid item xs={12} style={{ marginBottom: "8px" }}>
                  <Typography variant="h4" gutterBottom>
                    Sample Values
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    gutterBottom
                  >
                    Specify sample values for your parameters. These values can
                    be changed at the time of sending.
                    <br /> e.g. - {`{{1}}`}: Mohit, {`{{2}}`}: 5.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container alignItems="center">
                    {this.state.parameters.map((param, index) => (
                      <>
                        <Grid item xs={2} key={index + "_1"}>
                          <Typography variant="h5">
                            {` {{${index + 1}}} `}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={10}
                          style={{ marginBottom: 8 }}
                          key={index + "_2"}
                        >
                          <TextField
                            className={classes.textArea}
                            placeholder="Sample value"
                            name={index}
                            value={this.state.parameters[index]}
                            onChange={(e) => this.handleParamsInput(index, e)}
                          />
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </Grid>
              </Box>
            )}

            {this.state.templateCategory === "AUTHENTICATION" && (
              <Box mb={1} width="100%">
                <Typography variant="h4">Expiration Warning (Optional)</Typography>

                <TextField
                  type="number"
                  placeholder="Enter time in minutes (1-90)"
                  value={this.state.codeExpiryMinutes || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      this.setState({ codeExpiryMinutes: "" });
                      return;
                    }

                    const minutes = Number(value);
                    if (!isNaN(minutes) && minutes >= 1 && minutes <= 90) {
                      this.setState({ codeExpiryMinutes: minutes });
                    }
                  }}
                  inputProps={{ min: 1, max: 90 }}
                  className={classes.textField}
                  style={{ marginTop: "8px" }}
                />

                <Box display="flex" alignItems="center" mt={2}>
                  <Typography>Add Security Disclaimer</Typography>
                  <Switch
                    color="primary"
                    checked={!!this.state.viewSecurityMessage}
                    onChange={(e) => {
                      this.setState({
                        viewSecurityMessage: e.target.checked,
                      });
                    }}
                  />
                </Box>
              </Box>
            )}

            {/* Carousel Editor */}
            {this.state.templateType === "CAROUSEL" && (
              <CarouselEditor
                classes={classes}
                carouselTemplates={this.state.carouselTemplates}
                carouselIndex={this.state.carouselIndex}
                carouselMediaType={this.state.carouselMediaType}
                handleCarouselBodyInput={this.handleCarouselBodyInput}
                handleCarouselParamsInput={this.handleCarouselParamsInput}
                setCarouselMediaType={this.setCarouselMediaType}
              />
            )}

            {/* Limited Time Offer */}
            {this.state.templateType === "LIMITED_TIME_OFFER" && (
              <Box mb={1} width="100%">
                <Grid item xs={12} style={{ marginBottom: "8px" }}>
                  <Typography variant="h4" gutterBottom>
                    Limited Time Offer Text
                  </Typography>
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    Short text describing your offer. Up to 16 characters.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    className={classes.textArea}
                    placeholder="e.g. Offer expires in..."
                    value={this.state.limitedTimeOffer.text || ""}
                    onChange={this.handleLtoText}
                    inputProps={{ maxLength: 16 }}
                    FormHelperTextProps={{ className: classes.characterCounter }}
                    helperText={
                      this.state.limitedTimeOffer.text
                        ? `${this.state.limitedTimeOffer.text.length}/16`
                        : ""
                    }
                    style={{ marginTop: "8px" }}
                  />
                </Grid>
                <Box display="flex" alignItems="center" mt={2} style={{ height: 24, overflow: "visible" }}>
                  <Typography>Offer Expires</Typography>
                  <Tooltip
                    enterTouchDelay={0}
                    style={{ fontSize: "1.2em", marginLeft: 4, lineHeight: 1 }}
                    title="Turn on the toggle to make this a expiring offer. You can choose the expiration date when sending it to the user."
                  >
                    <Info color="disabled" />
                  </Tooltip>
                  <Switch
                    color="primary"
                    checked={!!this.state.limitedTimeOffer.has_expiration}
                    onChange={this.handleLtoExpirationToggle}
                  />
                </Box>
              </Box>
            )}

            {/* Footer */}

            {this.state.templateCategory !== "AUTHENTICATION" &&
              this.state.templateType !== "LIMITED_TIME_OFFER" &&
              this.state.templateType !== "CAROUSEL" && (
                <Box width="100%">
                  <Grid item xs={12} style={{ marginBottom: "8px" }}>
                    <Typography variant="h4" gutterBottom>
                      Template Footer{" "}
                      <span className={classes.optional}>(Optional)</span>
                    </Typography>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      Your message content. Upto 60 characters are allowed.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="templateFooter"
                      className={classes.textArea}
                      placeholder="Enter footer text here"
                      onChange={this.handleInput}
                      inputProps={{ maxLength: 60 }}
                      FormHelperTextProps={{
                        className: classes.characterCounter,
                      }}
                      helperText={
                        this.state.templateFooter &&
                        `${this.state.templateFooter.length}/60`
                      }
                      value={this.state.templateFooter}
                      disabled={inDialog}
                    />
                  </Grid>
                </Box>
              )}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              className={classes.preview}
              width="100%"
              style={{ display: window.innerWidth < 767 && "inline-block" }}
            >
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Template Preview
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Your template message preview. It will update as you fill in
                  the values in the form.
                </Typography>
              </Grid>
              <div
                style={{
                  minWidth: window.innerWidth >= 1200 && "340px",
                  display: "inline-grid",
                  justifyContent: "center",
                  padding: "0 16px",
                  marginTop: "40px",
                }}
              >
                {this.state.templateType === "CAROUSEL" ? (
                  <Box style={{ width: 340 }}>
                    {/* Card preview with left/right arrows + delete */}
                    <Box position="relative" display="flex" alignItems="center">
                      {/* Left arrow */}
                      <IconButton
                        size="small"
                        disabled={this.state.carouselIndex === 0}
                        onClick={() => this.setCarouselIndex(this.state.carouselIndex - 1)}
                        style={{ position: "absolute", left: -36, zIndex: 1 }}
                      >
                        <ChevronLeft />
                      </IconButton>

                      {/* Card preview */}
                      <Box position="relative" style={{ flex: 1 }}>
                        {/* Delete button top-right */}
                        {this.state.carouselTemplates.length > 1 && (
                          <IconButton
                            size="small"
                            onClick={this.deleteCarouselTemplate}
                            style={{
                              position: "absolute", top: -10, right: -10,
                              zIndex: 10, background: "white",
                              border: "1px solid #eee",
                              padding: 2,
                            }}
                          >
                            <Clear fontSize="small" style={{ color: "rgb(250,92,92)", fontSize: 14 }} />
                          </IconButton>
                        )}
                        <TemplateMessagePreview
                          parameters={this.state.parameters}
                          media={""}
                          bigIcon={true}
                          selectedTemplate={{
                            ...this.generateTemplate(),
                            type: "CAROUSEL",
                            carouselMediaType: this.state.carouselMediaType,
                            carouselTemplates: this.state.carouselTemplates,
                            carouselButtons: this.state.carouselButtons,
                            carouselIndex: this.state.carouselIndex,
                          }}
                          showDisclaimer={false}
                          carouselIndex={this.state.carouselIndex}
                          setCarouselIndex={this.setCarouselIndex}
                        />
                      </Box>

                      {/* Right arrow */}
                      <IconButton
                        size="small"
                        disabled={this.state.carouselIndex === this.state.carouselTemplates.length - 1}
                        onClick={() => this.setCarouselIndex(this.state.carouselIndex + 1)}
                        style={{ position: "absolute", right: -36, zIndex: 1 }}
                      >
                        <ChevronRight />
                      </IconButton>
                    </Box>

                    {/* Dots above Add Card */}
                    <Box display="flex" alignItems="center" justifyContent="center" mt={2} mb={1} style={{ gap: 6 }}>
                      {this.state.carouselTemplates.map((_, idx) => (
                        <Box
                          key={idx}
                          onClick={() => this.setCarouselIndex(idx)}
                          style={{
                            width: 8, height: 8, borderRadius: "50%",
                            background: idx === this.state.carouselIndex ? "#333" : "#bbb",
                            cursor: "pointer",
                          }}
                        />
                      ))}
                    </Box>

                    {/* Add Card button */}
                    {this.state.carouselTemplates.length < 10 && (
                      <Box display="flex" justifyContent="center">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<AddOutlined />}
                          onClick={() => this.addCarouselTemplate(this.state.carouselTemplates.length)}
                        >
                          Add Card
                        </Button>
                      </Box>
                    )}
                  </Box>
                ) : (
                  <TemplateMessagePreview
                    parameters={this.state.parameters}
                    media={""}
                    bigIcon={true}
                    selectedTemplate={{
                      ...this.generateTemplate(),
                      callToAction: this.state.actionType === "All"
                        ? (this.state.buttons || []).map((btn) => {
                          if (btn.type === "QUICK_REPLY") {
                            return { type: "QUICK_REPLY", buttonTitle: btn.text, buttonValue: "" };
                          }
                          if (btn.type === "COPY_CODE") {
                            const copyLabel = AUTH_LANGUAGES[this.state.templateLanguage]?.copyCode || "Copy Code";
                            return { type: "COPY_CODE", buttonTitle: copyLabel, buttonValue: btn.example || "" };
                          }
                          if (btn.type === "PHONE_NUMBER") {
                            return { type: "Phone Number", buttonTitle: btn.text, buttonValue: (btn.extension || "") + (btn.number || "") };
                          }
                          return { type: "URL", buttonTitle: btn.text, buttonValue: btn.url || "" };
                        })
                        : JSON.parse(
                          JSON.stringify(this.state.callToAction ?? [])
                        ).sort((a, b) => (a.type < b.type ? -1 : 1)),
                      templateCTAUrl:
                        interativeURLAction && interativeURLAction.buttonValue,
                      ...(this.state.templateType === "LIMITED_TIME_OFFER"
                        ? {
                          limitedTimeOffer: this.state.limitedTimeOffer,
                          ltoButtons: this.state.buttons,
                          headerType: this.state.templateHeaderType,
                        }
                        : {}),
                    }}
                    showDisclaimer={true}
                  />
                )}
              </div>
            </Box>
          </Grid>
        </Grid>

        {this.state.templateType !== "CAROUSEL" && (
          <Box my={6}>
            <Grid container>
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Interactive Actions
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  In addition to your message, you can send actions with your
                  message.
                  <br />
                  Maximum 25 characters are allowed in CTA button title & Quick
                  Replies.
                </Typography>
              </Grid>
              <Grid item container xs={12}>
                {(() => {
                  const legacyDisabled =
                    this.state.templateCategory === "AUTHENTICATION" ||
                    ["LIMITED_TIME_OFFER", "CAROUSEL"].includes(this.state.templateType);
                  return (
                    <RadioGroup
                      row
                      name="action"
                      value={this.state.actionType}
                      defaultValue="None"
                      onChange={this.handleRadioInput}
                    >
                      <FormControlLabel
                        value={"None"}
                        disabled={legacyDisabled}
                        control={<Radio color="primary" />}
                        label="None"
                      />
                      <FormControlLabel
                        value={"CAT"}
                        disabled={legacyDisabled}
                        control={<Radio color="primary" />}
                        label="Call to Actions"
                      />
                      <FormControlLabel
                        value={"QuickReplies"}
                        disabled={legacyDisabled}
                        control={<Radio color="primary" />}
                        label="Quick Replies"
                      />
                      <FormControlLabel
                        value={"All"}
                        control={<Radio color="primary" />}
                        label="All"
                      />
                    </RadioGroup>
                  );
                })()}
              </Grid>
              <InteractiveActions
                classes={classes}
                templateCategory={this.state.templateCategory}
                templateLanguage={this.state.templateLanguage}
                actionType={this.state.actionType}
                quickReplies={this.state.quickReplies}
                callToAction={this.state.callToAction}
                catAutoComplete={this.catAutoComplete}
                catInput={this.catInput}
                addCAT={this.addCAT}
                removeCAT={this.removeCAT}
                quickReplyInput={this.quickReplyInput}
                addQuickReply={this.addQuickReply}
                removeQuickReply={this.removeQuickReply}
                check={this.state.isClickTrackingEnabled}
                handleChange={this.handleChange}
                buttons={this.state.buttons}
                addNewButton={this.addNewButton}
                removeButtons={this.removeButtons}
                type={this.state.templateType}
                activePlan={activePlan}
                partnerId={this.props.partner?._id || this.props.partner?.id}
                partnerType={this.props.partner?.type}
              />
            </Grid>
          </Box>
        )}

        {/* Carousel Interactive Actions — reuses InteractiveActions with "All" locked */}
        {this.state.templateType === "CAROUSEL" && (
          <Box my={6}>
            <Grid container>
              <Grid item xs={12} style={{ marginBottom: "8px" }}>
                <Typography variant="h4" gutterBottom>
                  Interactive Actions
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Button types are consistent across all cards (max 2). Titles and values can be set per card.
                  <br />
                  Quick Reply, URL and Phone Number buttons are supported.
                </Typography>
              </Grid>
              <Grid item container xs={12}>
                <RadioGroup row value="All">
                  <FormControlLabel value="None" disabled control={<Radio color="primary" />} label="None" />
                  <FormControlLabel value="CAT" disabled control={<Radio color="primary" />} label="Call to Actions" />
                  <FormControlLabel value="QuickReplies" disabled control={<Radio color="primary" />} label="Quick Replies" />
                  <FormControlLabel value="All" control={<Radio color="primary" />} label="All" />
                </RadioGroup>
              </Grid>
              <InteractiveActions
                classes={classes}
                templateCategory={this.state.templateCategory}
                templateLanguage={this.state.templateLanguage}
                actionType="All"
                quickReplies={[]}
                callToAction={[]}
                catAutoComplete={(index, value, reason, isExt) => {
                  if (reason === "select-option" && isExt) this.carouselButtonExtension(index, value);
                }}
                catInput={(index, elem) => this.carouselButtonInput(index, elem)}
                addCAT={() => { }}
                removeCAT={() => { }}
                quickReplyInput={(index, elem) => this.carouselButtonInput(index, elem)}
                addQuickReply={() => { }}
                removeQuickReply={() => { }}
                check={this.state.isClickTrackingEnabled}
                handleChange={this.handleChange}
                buttons={this.state.carouselButtons[this.state.carouselIndex] || []}
                addNewButton={(type) => this.addCarouselButton(type)}
                removeButtons={(index) => this.removeCarouselButton(index)}
                type="CAROUSEL"
                activePlan={activePlan}
                partnerId={this.props.partner?._id || this.props.partner?.id}
                partnerType={this.props.partner?.type}
              />
            </Grid>
          </Box>
        )}

        <Box my={6} />
        {this.state.err ? (
          <Box>
            <Typography
              variant="body2"
              color="error"
              style={{ marginBottom: 12 }}
            >
              {this.state.err}
            </Typography>
            {this.state.err.includes("Floating") && (
              <Link
                href="https://m.aisensy.com/how-to-fix-floating-parameter-issue-in-template-message"
                target="_blank"
                color="primary"
                size="small"
              >
                <Typography variant="body2">
                  How to fix floating parameter issue?
                </Typography>
              </Link>
            )}
          </Box>
        ) : (
          ""
        )}
        {this.state.success ? (
          <Box>
            <Typography variant="h3" color="primary">
              Template successfully submitted for approval !
            </Typography>
          </Box>
        ) : (
          ""
        )}
        <Box my={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              {this.state.isSubmitting ? (
                <CircularProgress />
              ) : (
                <>
                  {!(inDialog && this.state.success) && (
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.autoFillAndSubmit}
                      endIcon={
                        this.state.isSubmitting ? (
                          <CircularProgress size={20} />
                        ) : (
                          ""
                        )
                      }
                      disabled={this.state.isSubmitting}
                      style={{
                        marginRight: 8,
                        fontSize: "14px",
                        padding: "8px 16px",
                      }}
                    >
                      Submit
                    </Button>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Box>
        {/* Show snackbar */}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackbar.open}
          onClose={() =>
            this.setState({ snackbar: { open: false, message: "" } })
          }
          message={this.state.snackbar.message}
          key={"snack"}
          autoHideDuration={3000}
        >
          <Alert
            open={this.state.snackbar.open}
            onClose={() =>
              this.setState({ snackbar: { open: false, message: "" } })
            }
            severity="error"
          >
            {this.state.snackbar.message}
          </Alert>
        </Snackbar>
        {/* Show dialog on backpress */}
        <Dialog
          open={showDialog && !isSubmitted}
          onClose={toggleDialog}
          maxWidth={"xs"}
        >
          <Box className={classes.dialogWrapper}>
            <DialogTitle className={classes.dialogTitle}>
              <Typography variant="h3">Discard Template</Typography>
            </DialogTitle>
            <Clear className={classes.icon} onClick={toggleDialog} />
          </Box>
          <DialogContent>
            <DialogContentText
              style={{
                color: "rgb(0,0,0,0.67)",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              If you discard this template then all changes made by you will be
              lost. You can also save this template as a draft and modify it at
              a later point.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            style={{ paddingBottom: "16px", paddingRight: "24px" }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                toggleDialog();
                this.props.history.push(
                  "/projects/" + projectId + "/manage/template-message"
                );
              }}
            >
              Discard template
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                toggleDialog();
                this.props.history.push(
                  "/projects/" + projectId + "/manage/template-message"
                );
              }}
              autoFocus
            >
              Save to Draft
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={!!this.state.alertMsg}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={this.onSnackbarClose}
          className={classes.snackbar}
          autoHideDuration={this.state.alertType === "error" ? 8000 : 3000}
        >
          <Alert severity={this.state.alertType} onClose={this.onSnackbarClose}>
            {this.state.alertMsg}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

function CarouselEditor({
  classes,
  carouselTemplates,
  carouselIndex,
  carouselMediaType,
  handleCarouselBodyInput,
  handleCarouselParamsInput,
  setCarouselMediaType,
}) {
  const currentCard = carouselTemplates[carouselIndex] || {};

  return (
    <Box width="100%">
      {/* Media type — dropdown, same style as Template Type */}
      <Box mb={6} width="100%">
        <Grid item xs={12} style={{ marginBottom: "8px" }}>
          <Typography variant="h4" gutterBottom>
            Carousel Media Type
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            All cards in this carousel will use the same media type.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            disableClearable
            options={CAROUSEL_MSG_TYPES.map((t) => t.type)}
            onChange={(e, value, reason) => {
              if (reason === "select-option") setCarouselMediaType(value);
            }}
            value={carouselMediaType}
            renderInput={(params) => (
              <TextField
                {...params}
                className={classes.textField}
                InputProps={{ ...params.InputProps }}
                placeholder="Select media type"
              />
            )}
          />
        </Grid>
      </Box>

      {/* Card body — styled exactly like Template Format */}
      <Box mb={6} width="100%">
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: "8px" }}>
            <Typography variant="h4" gutterBottom>
              Card {carouselIndex + 1} Body <Typography component="span" variant="body2" color="textSecondary">(Optional)</Typography>
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Use text formatting - *bold* , _italic_ & ~strikethrough~
              <br />
              Your card body text. Up to 160 characters.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={2}
              rowsMax={10}
              className={classes.textArea}
              placeholder="Enter card body text..."
              value={currentCard.templateFooter || ""}
              onChange={handleCarouselBodyInput}
              inputProps={{ maxLength: 160 }}
              FormHelperTextProps={{ className: classes.characterCounter }}
              helperText={`${(currentCard.templateFooter || "").length}/160`}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Sample values — only shown when card has params */}
      {(currentCard.parameters || []).length > 0 && (
        <Box mb={6}>
          <Grid item xs={12} style={{ marginBottom: "8px" }}>
            <Typography variant="h4" gutterBottom>
              Sample Values
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Specify sample values for your parameters.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container alignItems="center">
              {(currentCard.parameters || []).map((param, pIdx) => (
                <React.Fragment key={pIdx}>
                  <Grid item xs={2}>
                    <Typography variant="h5">{`{{${pIdx + 1}}}`}</Typography>
                  </Grid>
                  <Grid item xs={10} style={{ marginBottom: 8 }}>
                    <TextField
                      className={classes.textArea}
                      placeholder="Sample value"
                      value={param}
                      onChange={(e) => handleCarouselParamsInput(pIdx, e)}
                    />
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </Box>
      )}

    </Box>
  );
}

function ClickTracking({ activePlan, buttons, check, toggleClickTracking, partnerId, partnerType }) {
  if (partnerType === "DIRECT") return null;
  const hasUrlButton = (buttons || []).some((b) => ["URL", "url"].includes(b.type));
  const isNoLabelPartner = TENANT_ID !== partnerId && AISENSY_PARTNER_ID !== partnerId;
  if (!hasUrlButton || !isNoLabelPartner) return null;

  const isEligible =
    activePlan &&
    (activePlan.toUpperCase().includes("PRO") ||
      activePlan.toUpperCase().includes("ENTERPRISE"));

  const trackingBaseUrl = isNoLabelPartner
    ? `${NO_LABEL_URL}/tck/xxxx`
    : `${LINK_GEN_BACKEND_URL}/tck/xxxx`;

  return (
    <>
      <Grid container alignItems="center" style={{ marginTop: 10 }}>
        <Typography variant="body1">Enable Click Tracking</Typography>
        <Box ml={1} style={{ marginTop: "4px" }}>
          <Tooltip
            enterTouchDelay={0}
            style={{ fontSize: "1.2em" }}
            title={`To track clicks we will send the end users a link of the format ${trackingBaseUrl} which will redirect to your link on click.`}
          >
            <Info color="disabled" />
          </Tooltip>
        </Box>
        <Tooltip
          interactive
          title={
            !isEligible ? (
              <Typography variant="body2">Please upgrade to a higher Plan</Typography>
            ) : ""
          }
        >
          <span style={{ marginLeft: 24 }}>
            <Switch
              checked={!!check}
              onChange={toggleClickTracking}
              name="isClickTrackingEnabled"
              disabled={!isEligible}
              color="primary"
            />
          </span>
        </Tooltip>
      </Grid>
      {check && (
        <Box
          padding="10px 16px"
          style={{
            background: "#f7ebffdb",
            marginTop: 12,
            borderRadius: "8px",
          }}
        >
          <Typography variant="body2">
            To track clicks we will send the end users a link of the format{" "}
            <strong>{trackingBaseUrl}</strong> which will redirect to your link
            on click.
          </Typography>
        </Box>
      )}
    </>
  );
}

function TempButton({ label, maxCount, actionFunc, buttons, count, type, category }) {
  const maxButtons = type === "CAROUSEL" ? 2 : 10;
  const totalButtons = buttons.length;
  const isDisabled =
    count >= maxCount ||
    totalButtons >= maxButtons ||
    (category === "AUTHENTICATION" && label !== "Copy Code") ||
    (label === "Copy Code" && !["MARKETING", "AUTHENTICATION"].includes(category)) ||
    (type === "CAROUSEL" && label === "Copy Code");

  return (
    <Box my={3}>
      <Button
        startIcon={<AddOutlined />}
        variant="outlined"
        disabled={isDisabled}
        onClick={actionFunc}
      >
        {label}
        <Chip
          label={Math.max(0, Math.min(maxCount - count, maxButtons - totalButtons))}
          size="small"
          style={{ marginLeft: "8px" }}
          disabled={isDisabled}
        />
      </Button>
    </Box>
  );
}

function InteractiveActions(props) {
  const {
    classes,
    templateCategory,
    templateLanguage,
    actionType,
    callToAction,
    quickReplies,
    catAutoComplete,
    catInput,
    addCAT,
    removeCAT,
    quickReplyInput,
    addQuickReply,
    removeQuickReply,
    check,
    handleChange,
    buttons,
    addNewButton,
    removeButtons,
    type: templateType,
    activePlan,
    partnerId,
    partnerType,
  } = props;

  if (templateCategory === "AUTHENTICATION" && actionType !== "All") {
    const copyCodeText = AUTH_LANGUAGES[templateLanguage]?.copyCode || "Copy Code";
    return (
      <Grid item container xs={12} alignItems="center" spacing={2} style={{ marginTop: "16px", marginLeft: "8px" }}>
        <Grid item xs={12} md="auto">
          <Typography variant="h5" color="textSecondary">{copyCodeText} :</Typography>
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            className={classes.textArea}
            placeholder="Sample values"
            value={callToAction[0]?.buttonValue || ""}
            inputProps={{ maxLength: 15 }}
            onChange={(e) => {
              const value = e.target.value.substring(0, 15);
              const elem = { target: { name: "buttonValue", value } };
              catInput(0, elem);
            }}
          />
        </Grid>
      </Grid>
    );
  }

  function getOptions(e, index) {
    const options = ["Phone Number", "URL"];
    if (callToAction.length === 1) {
      return options;
    } else {
      return options.filter((k) => k !== callToAction[Number(!index)].type);
    }
  }

  // Count buttons by type for "All" mode
  const typeCounts = (buttons || []).reduce((acc, btn) => {
    acc[btn.type] = (acc[btn.type] || 0) + 1;
    return acc;
  }, {});
  switch (actionType) {
    case "None":
      return <div></div>;
    case "QuickReplies":
      return (
        <React.Fragment>
          {quickReplies.map((e, index) => (
            <Grid item container xs={12} alignItems="center" spacing={2} key={index}>
              <Grid item xs={12} md={"auto"}>
                <Typography variant="h5">Quick Reply {index + 1} :</Typography>
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  name="quickReplies"
                  className={classes.textArea}
                  placeholder="Button title"
                  inputProps={{ maxLength: 25 }}
                  FormHelperTextProps={{ className: classes.inlineCharacterCounter }}
                  helperText={e ? `${e.length}/25` : ""}
                  value={e}
                  onChange={(elem) => quickReplyInput(index, elem)}
                />
              </Grid>
              <Grid item xs={12} md={"auto"}>
                <IconButton onClick={() => removeQuickReply(index)}>
                  <Clear />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Grid item container xs={12} alignItems="center">
            <Box my={3}>
              {quickReplies.length < 3 && (
                <Button startIcon={<AddOutlined />} variant="outlined" onClick={addQuickReply}>
                  Quick Reply
                </Button>
              )}
            </Box>
          </Grid>
        </React.Fragment>
      );
    case "CAT":
      return (
        <React.Fragment>
          {callToAction.map((e, index) => (
            <Grid item container xs={12} alignItems="center" spacing={2} key={index}>
              <Grid item xs={12} md={2} style={{ display: "contents" }}>
                <Typography variant="h5">Call to Action {index + 1} :</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  disableClearable
                  options={getOptions(e, index)}
                  onChange={(ev, value, reason) => catAutoComplete(index, value, reason)}
                  value={e.type}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{ ...params.InputProps }}
                      placeholder="Select action type"
                      name="callToAction"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="buttonTitle"
                  className={classes.textArea}
                  placeholder="Button title"
                  inputProps={{ maxLength: 25 }}
                  value={e.buttonTitle}
                  onChange={(elem) => catInput(index, elem)}
                />
              </Grid>
              <Grid item xs={12} md={e.type === "Phone Number" ? 4 : 3}>
                {e.type === "Phone Number" ? (
                  <Box display="flex" alignItems="center">
                    <Autocomplete
                      disableClearable
                      options={dialCodes}
                      getOptionLabel={(opt) => typeof opt === "string" ? (opt ? `+${opt}` : "") : opt.dialCode}
                      filterOptions={(options, { inputValue }) => {
                        const q = inputValue.toLowerCase();
                        return options.filter((o) => o.name.toLowerCase().includes(q) || o.dialCode.includes(q));
                      }}
                      onChange={(ev, value, reason) => catAutoComplete(index, typeof value === "string" ? value : value.dialCode, reason, true)}
                      value={e.extension || ""}
                      style={{ minWidth: 90, maxWidth: 90, marginRight: 8 }}
                      classes={{ popper: classes.dialCodePopper }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="+1" InputProps={{ ...params.InputProps }} />
                      )}
                      renderOption={(option) => (
                        <span style={{ whiteSpace: "nowrap" }}>{option.name} {option.dialCode}</span>
                      )}
                    />
                    <TextField
                      name="buttonValue"
                      className={classes.textArea}
                      placeholder="Phone number"
                      style={{ flex: 1 }}
                      value={e.buttonValue}
                      onChange={(elem) => catInput(index, elem)}
                    />
                  </Box>
                ) : (
                  <TextField
                    name="buttonValue"
                    className={classes.textArea}
                    placeholder="Button value"
                    value={e.buttonValue}
                    onChange={(elem) => catInput(index, elem)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={"auto"} style={{ width: 0 }}>
                <IconButton onClick={() => removeCAT(index)}>
                  <Clear />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Grid item container xs={12} alignItems="center">
            <Box my={2}>
              {callToAction.length < 2 && (
                <Button startIcon={<AddOutlined />} variant="outlined" onClick={addCAT}>
                  Call to Action
                </Button>
              )}
            </Box>
          </Grid>
          <ClickTracking
            activePlan={activePlan}
            buttons={callToAction}
            check={check}
            toggleClickTracking={handleChange}
            partnerId={partnerId}
            partnerType={partnerType}
          />
        </React.Fragment>
      );
    case "All": {
      let qrIdx = 0;
      let ctaIdx = 0;
      return (
        <React.Fragment>
          {(buttons || []).map((btn, index) => {
            if (btn.type === "QUICK_REPLY") {
              qrIdx++;
              return (
                <Grid item container xs={12} alignItems="center" spacing={2} key={index}>
                  <Grid item xs={12} md={"auto"}>
                    <Typography variant="h5">Quick Reply {qrIdx} :</Typography>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      className={classes.textArea}
                      placeholder="Button title"
                      inputProps={{ maxLength: 25 }}
                      FormHelperTextProps={{ className: classes.inlineCharacterCounter }}
                      helperText={btn.text ? `${btn.text.length}/25` : ""}
                      value={btn.text || ""}
                      onChange={(elem) => quickReplyInput(index, elem)}
                    />
                  </Grid>
                  <Grid item xs={12} md={"auto"}>
                    <IconButton onClick={() => removeButtons(index)}>
                      <Clear />
                    </IconButton>
                  </Grid>
                </Grid>
              );
            }

            if (btn.type === "COPY_CODE") {
              return (
                <Grid item container xs={12} alignItems="center" spacing={2} key={index}>
                  <Grid item xs={12} md={"auto"}>
                    <Typography variant="h5">Copy Code :</Typography>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      className={classes.textArea}
                      placeholder={templateCategory === "AUTHENTICATION" ? "Code" : "Coupon Code"}
                      inputProps={{ maxLength: 15 }}
                      FormHelperTextProps={{ className: classes.inlineCharacterCounter }}
                      helperText={btn.example ? `${btn.example.length}/15` : ""}
                      value={btn.example || ""}
                      onChange={(e) => {
                        const elem = { target: { name: "example", value: e.target.value.substring(0, 15) } };
                        catInput(index, elem);
                      }}
                    />
                  </Grid>
                  {templateCategory !== "AUTHENTICATION" && (
                    <Grid item xs={12} md={"auto"}>
                      <IconButton onClick={() => removeButtons(index)}>
                        <Clear />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              );
            }

            // URL or PHONE_NUMBER
            ctaIdx++;
            const displayType = btn.type === "PHONE_NUMBER" ? "Phone Number" : "URL";
            return (
              <Grid item container xs={12} alignItems="center" spacing={2} key={index}>
                <Grid item xs={12} md={2} style={{ display: "contents" }}>
                  <Typography variant="h5">Call to Action {ctaIdx} :</Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    className={classes.textArea}
                    value={displayType}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    className={classes.textArea}
                    placeholder="Button title"
                    inputProps={{ maxLength: 25 }}
                    FormHelperTextProps={{ className: classes.inlineCharacterCounter }}
                    helperText={btn.text ? `${btn.text.length}/25` : ""}
                    value={btn.text || ""}
                    onChange={(e) => {
                      const elem = { target: { name: "buttonTitle", value: e.target.value } };
                      catInput(index, elem);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  {btn.type === "PHONE_NUMBER" ? (
                    <Box display="flex" alignItems="center">
                      <Autocomplete
                        disableClearable
                        options={dialCodes}
                        getOptionLabel={(opt) => typeof opt === "string" ? (opt ? `+${opt}` : "") : opt.dialCode}
                        filterOptions={(options, { inputValue }) => {
                          const q = inputValue.toLowerCase();
                          return options.filter((o) => o.name.toLowerCase().includes(q) || o.dialCode.includes(q));
                        }}
                        onChange={(ev, value, reason) => catAutoComplete(index, typeof value === "string" ? value : value.dialCode, reason, true)}
                        value={btn.extension || ""}
                        style={{ minWidth: 90, maxWidth: 90, marginRight: 8 }}
                        classes={{ popper: classes.dialCodePopper }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="+1" InputProps={{ ...params.InputProps }} />
                        )}
                        renderOption={(option) => (
                          <span style={{ whiteSpace: "nowrap" }}>{option.name} {option.dialCode}</span>
                        )}
                      />
                      <TextField
                        className={classes.textArea}
                        placeholder="Phone number"
                        style={{ flex: 1 }}
                        value={btn.number || ""}
                        onChange={(e) => {
                          const elem = { target: { name: "buttonValue", value: e.target.value } };
                          catInput(index, elem);
                        }}
                      />
                    </Box>
                  ) : (
                    <TextField
                      className={classes.textArea}
                      placeholder="https://example.com/{{1}}"
                      value={btn.url || ""}
                      onChange={(e) => {
                        const elem = { target: { name: "buttonValue", value: e.target.value } };
                        catInput(index, elem);
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={"auto"} style={{ width: 0 }}>
                  <IconButton onClick={() => removeButtons(index)}>
                    <Clear />
                  </IconButton>
                </Grid>
              </Grid>
            );
          })}

          {/* Click Tracking */}
          <ClickTracking
            activePlan={activePlan}
            buttons={buttons || []}
            check={check}
            toggleClickTracking={handleChange}
            partnerId={partnerId}
            partnerType={partnerType}
          />

          {/* Add buttons */}
          <Grid item container xs={12} alignItems="center" spacing={2}>
            <TempButton
              label="Quick Replies"
              maxCount={10}
              count={typeCounts.QUICK_REPLY || 0}
              actionFunc={() => addNewButton("QUICK_REPLY")}
              buttons={buttons || []}
              type={templateType}
              category={templateCategory}
            />
            <Box mx={1} />
            <TempButton
              label="URL"
              maxCount={2}
              count={typeCounts.URL || 0}
              actionFunc={() => addNewButton("URL")}
              buttons={buttons || []}
              type={templateType}
              category={templateCategory}
            />
            <Box mx={1} />
            <TempButton
              label="Phone Number"
              maxCount={1}
              count={typeCounts.PHONE_NUMBER || 0}
              actionFunc={() => addNewButton("PHONE_NUMBER")}
              buttons={buttons || []}
              type={templateType}
              category={templateCategory}
            />
            <Box mx={1} />
            <TempButton
              label="Copy Code"
              maxCount={1}
              count={typeCounts.COPY_CODE || 0}
              actionFunc={() => addNewButton("COPY_CODE")}
              buttons={buttons || []}
              type={templateType}
              category={templateCategory}
            />
          </Grid>
        </React.Fragment>
      );
    }
    default:
      return "";
  }
}

const styles = (theme) => ({
  root: {
    background: "white",
    borderRadius: "8px",
    minHeight: "200px",
  },
  textField: {
    width: "100%",
    "& .MuiAutocomplete-input": {
      textOverflow: "clip",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  textArea: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  previewWrapper: {
    width: 350,
    [theme.breakpoints.down("sm")]: {
      width: 300,
    },
  },
  previewContainer: {
    minHeight: 160,
    background: "#EBF5F3",
    width: "100%",
    borderRadius: 8,
  },
  preview: {
    display: "inline-grid",
    width: "100%",
    //justifyContent: "center",
    position: "sticky",
    top: "100px",
    [theme.breakpoints.down("sm")]: {
      position: "static",
    },
  },
  optional: {
    fontSize: "14px",
    color: "#808080",
    fontWeight: "500",
  },
  inlineCharacterCounter: {
    marginLeft: "auto",
    height: 0,
    bottom: "25px",
    position: "absolute",
    right: "10px",
  },
  characterCounter: {
    height: 0,
    position: "absolute",
    right: 0,
    bottom: "-5px",
  },
  dialogWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  icon: {
    marginRight: 24,
    "&:hover": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    "& .MuiTypography-h6": {
      fontSize: 20,
      fontWeight: 600,
      color: "rgb(0,0,0,0.87)",
    },
  },
  dialCodePopper: {
    width: "280px !important",
  },
  textFieldPopper: {
    [theme.breakpoints.down("md")]: {
      left: "12px !important",
      minWidth: "calc(100% - 35px)",
    },
    [theme.breakpoints.up("md")]: {
      left: "calc(12.5vw - 16px) !important",
      minWidth: "calc(25vw + 54px)",
    },
  },
  qualityStatus: {
    "& .MuiChip-label": {
      color: "white",
    },
  },
});

const CreateTemplateconnect = connect(
  (state) => ({
    allBusiness: state.business.allBusiness,
    allProjects: state.projects.allProjects,
    assistants: state.assistants.assistants,
    partner: state.partner.partner,
  }),
  { fetchBusiness, fetchProject, createnewTemplate }
)(CreateTemplateMsgForm);

export default withStyles(styles)(withRouter(CreateTemplateconnect));
